import { RRSpinnerModel } from '../../spinner/models/spinner.model';

export class RRWebviewerSettings {
  wireframeOption?: boolean;
  canvasId?: string;
  loadingSpinner?: RRSpinnerModel;
  disableGround?: boolean;
}
